// extracted by mini-css-extract-plugin
export var locationCard = "_g4-0";